import { render, staticRenderFns } from "./FormPromotion.vue?vue&type=template&id=3b654d9e&scoped=true&"
import script from "./FormPromotion.vue?vue&type=script&lang=js&"
export * from "./FormPromotion.vue?vue&type=script&lang=js&"
import style0 from "./FormPromotion.vue?vue&type=style&index=0&id=3b654d9e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b654d9e",
  null
  
)

export default component.exports